import React from 'react';

import { CircularProgress, Paper } from '@mui/material';

const TinyLoading: React.FC = () => (
  <Paper
    elevation={3}
    style={{
      position: 'fixed',
      bottom: 12,
      right: 12,
      padding: 10,
      borderRadius: 12,
      zIndex: 15000,
      pointerEvents: 'none',
      background: 'rgba(255,255,255,0.95)',
    }}
  >
    <CircularProgress size={36} thickness={5} />
  </Paper>
);

export default TinyLoading;
